import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=cc06a56c&scoped=true&"
import script from "./practice.vue?vue&type=script&lang=js&"
export * from "./practice.vue?vue&type=script&lang=js&"
import style0 from "./practice.vue?vue&type=style&index=0&id=cc06a56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc06a56c",
  null
  
)

export default component.exports